<template>
    <div class="obrazec obnova ovoj" id="html">
        <div class="glava">
            <div class="levi-logo">
              <img src='~@/assets/ikc.png'/>
            </div>
            <div class="desni-info">
                <p>Pivola 8, SI2311 Hoče</p>
                <p>Tel.: (02) 613 08 31, -32</p>
                <p>info@ikc-um.si</p>
                <p><a href="www.ikc-um.si">www.ikc-um.si</a></p>
            </div>
        </div>
		<div class="noga-izven">
        		<div class="stevilka-strani" >Obr. E_6.21, rev.12, 30.05.2024, stran </div>
        		
      	</div>
        <div id="vsebina">
		<kbutton class="gumbtiskaj" :theme-color="'primary'" :rounded="'full'" id="tiskaj">
			<font-awesome-icon icon="print"  size="6x"/>
		</kbutton>

        <table style="width:100%" class="mt-1">
            <colgroup>
				<col style="width:75%">
				<col style="width:auto">
			</colgroup>

<tr>
    <td></td>
    <td>Datum: {{ (new Date(certifikat.porocilo.odlocitev.datumporocila)).toLocaleDateString('SL-si')  }}</td>
</tr>
<tr>
    <td></td>
    <td>Številka: {{ certifikat.porocilo.stevilkaporocila }}</td>
</tr>
<tr>
    <td><b>{{ certifikat.porocilo.nosilec.naziv }}</b></td>
    <td></td>
</tr>

<tr>
    <td>{{ certifikat.porocilo.nosilec.naslov }}</td>
    <td></td>
</tr>
<tr>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
</tr>
<tr>
    <td><b>{{ certifikat.porocilo.nosilec.postnastevilka+" "+certifikat.porocilo.nosilec.posta, }}</b></td>
    <td></td>
</tr>

        </table>
		<div class="zapisnik-glava mt-1">
			<h2>POROČILO O CERTIFIKACIJI</h2>
            <h4>INTEGRIRANA PRIDELAVA</h4>
		</div>


		<table class="zapisnik-podatki mt-1">
			<colgroup>
				<col style="width:50%">
				<col style="width:auto">
			</colgroup>  
			<tr>
				<td class="td-bold">Certifikacija je bila izvedena dne:</td>
				<td>{{ (new Date(certifikat.porocilo.odlocitev.datumodlocitve)).toLocaleDateString('SL-si') }}</td>
			</tr>
			<tr>
				
			</tr>
		</table>

		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:25%">
				<col style="width:75%">
			</colgroup>  
			<tr>
				<td colspan="2" class="zapisnik-tabela-glava">Podatki o kontrolnem pregledu/vrednotenju</td>
			</tr> 
			<tr>
				<td>Izvajalec:</td>
				<td>{{ certifikat.imetnik }}</td>
			</tr>
			<tr>
				<td >Naslov KMG:</td>
				<td>{{ certifikat.naslov }}</td>
			</tr>
            <tr>
				<td >Vrsta kontrolnega pregleda / vrednotenja:</td>
				<td>{{ certifikat.porocilo.vrstakontrole }}</td>
			</tr>
			<tr>
				<td >Datum:</td>
				<td>{{ (new Date(certifikat.porocilo.datumkontrole)).toLocaleDateString('SL-si') }}</td>
			</tr>
            <tr>
				<td >Vzorčenje:</td>
				<td>{{ certifikat.porocilo.vzorcenje?"DA":"NE" }}</td>
			</tr>
            <tr>
				<td >Št. vzorca:</td>
				<td>{{ certifikat.porocilo.vzorci.map(v=>v.idvzorca).join(", ") }}</td>
			</tr>
            <tr>
				<td >Datum vzorčenja:</td>
				<td>{{ certifikat.porocilo.vzorci.map(v=>(new Date(v.datumvzorcenja)).toLocaleDateString('SL-si')).join(", ") }}</td>
			</tr>
			

		</table>

        
		<table class="obroba mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:100%">
				
			</colgroup>  
			<tr>
				<td class="zapisnik-tabela-glava">Rezultat</td>
			</tr> 
            <tr>
				<td>Pri izvajalcu je bil izveden kontrolni pregled / vrednotenje skladno s Pravilnikom o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/23 s sprem. in dop.) in internim dokumentom Pravila postopka certificiranja, 1.80doc v svoji veljavni izdaji.</td>
			</tr> 

        </table>

        

        <table v-if="certifikat.porocilo.neskladja.length<=0" class="obroba mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:100%">
				
			</colgroup>  
			<tr>
				<td>V sklopu kontrolnega pregleda / vrednotenja niso bila identificirana neskladja.</td>
			</tr> 
            

        </table>

       
        <table v-if="certifikat.porocilo.neskladja.filter(n=>n.odpravljeno).length>0" class="obroba mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:70%">
                <col style="width:12.5%">
                <col style="width:17.5%">
				
			</colgroup>  
            <tr>
				<td colspan="3">V sklopu kontrolnega pregleda / vrednotenja so bila Identificirana v nadaljevanju navedena neskladja, ki sicer niso zadržala izdaje certifikata, saj so bila odpravljena v roku z dodatnimi dokazili, prejetimi pisno oz. preko e-pošte na naslov IKC UM oz. ob dodatni kontroli.</td>
			</tr> 
			<tr>
			<th class="fake-td">Opis neskladnosti</th>
            <th class="fake-td">Stopnja NS</th>
            <th class="fake-td">Datum odprave NS</th>
			</tr> 
            
            <tr v-for="neskladnost in certifikat.porocilo.neskladja.filter(n=>n.odpravljeno)">
			<td>{{neskladnost.opis}}</td>
            <td style="text-align: center;">{{ neskladnost.stopnjaneskladja }}</td>
            <td style="text-align: center;">{{ (new Date(neskladnost.datumodprave)).toLocaleDateString('SL-si') }}</td>
			</tr> 
            

        </table>


        <table v-if="certifikat.porocilo.neskladja.filter(n=>!n.odpravljeno).length>0" class="obroba mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:85%">
                <col style="width:15%">
                
				
			</colgroup>  
            <tr>
				<td colspan="2">V sklopu kontrolnega pregleda / vrednotenja so bila identificirana v nadaljevanju navedena neskladja, ki niso bila odpravljena v roku ali predstavljajo izključitvene kriterije (NS4) skladno s Pravilnikom o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/23 s sprem. in dop.) oz. je analizni izvid pokazal prisotnost nedovoljenih aktivnih snovi.</td>
			</tr> 
			<tr>
			<th class="fake-td">Opis neskladnosti</th>
            <th class="fake-td" >Stopnja NS</th>
           
			</tr> 
            
            <tr v-for="neskladnost in certifikat.porocilo.neskladja.filter(n=>!n.odpravljeno)">
			<td>{{neskladnost.opis}}</td>
            <td style="text-align: center;">{{ neskladnost.stopnjaneskladja }}</td>
           
			</tr> 
            

        </table>

        <table v-if="certifikat.porocilo.vzorcenje" class="obroba mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:25%">
                <col style="width:75%">
                
				
			</colgroup>  
            <tr>
				<td colspan="2">V sklopu kontrolnega pregleda / vrednotenja in v skladu z letnim načrtom vzorčenja je kontrolor na vašem KMG odvzel vzorec za laboratorijsko analizo na prisotnost in vsebnost aktivnih snovi FFS v pridelku. </td>
			</tr> 
			<tr>
				<td class="fake-td">Lokacija vzorčenja:</td>
				<td>{{ certifikat.porocilo.vzorci.map(v=>v.lokacija).join(", ") }}</td>
			</tr>
            <tr>
				<td class="fake-td">Kultura:</td>
				<td>{{ certifikat.porocilo.vzorci.map(v=>v.kultura).join(", ") }}</td>
			</tr>
            <tr>
				<td class="fake-td">Št. analiznega izvida:</td>
				<td>{{ certifikat.porocilo.vzorci.map(v=>v.idporocila).join(", ") }}</td>
			</tr>
            <tr>
				<td class="fake-td">Datum analiznega izvida:</td>
				<td>{{ certifikat.porocilo.vzorci.map(v=>(new Date(v.datumvzorcenja)).toLocaleDateString('SL-si')).join(", ")  }}</td>
			</tr>
            <tr>
				<td class="fake-td">Rezultat:</td>
				<td>{{ certifikat.porocilo.vzorci.map(v=>v.rezultat).join(", ")  }}</td>
			</tr>
            <tr>
				<td colspan="2" v-if="certifikat.porocilo.vzorci.filter(v=>!v.skladno).length<=0">V odvzetem vzorcu ni bilo prisotnih nedovoljenih ostankov aktivnih snovi FFS. Vsi preostali analizirani ostanki aktivnih snovi FFS so bili pod mejo detekcije laboratorijske metode.</td>
                <td colspan="2" v-else>V odvzetem vzorcu so bili detektirani ostanki aktivnih snovi, ki niso registrirani za uporabo v vzorčenem pridelku / kulturi. </td>
			</tr>
            

        </table>

        <table v-if="certifikat.porocilo.nadaljniukrepiizvajalca.length>0" class="obroba mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:75%">
                <col style="width:25%">
                
				
			</colgroup>  
            <tr>
				<td colspan="2">V postopku certificiranja so bili izvajalcu določeni naslednji nadaljnji ukrepi:</td>
			</tr> 
			<tr>
			<th class="fake-td">Nadaljni ukrep</th>
            <th class="fake-td">Rok</th>
           
			</tr> 
            
            <tr v-for="ukrep in certifikat.porocilo.nadaljniukrepiizvajalca">
			<td>{{ukrep.ukrep}}</td>
            <td style="text-align: center;">{{(new Date(ukrep.rok)).toLocaleDateString('SL-si')}}</td>
           
			</tr> 
            

        </table>

        <table class="obroba mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:25%">
				<col style="width:75%">
			</colgroup>  
			<tr>
				<td colspan="2" class="zapisnik-tabela-glava">Odločitev o certifikatu:</td>
			</tr> 
            <tr>
				<td colspan="2" >Certifikator je odločil o izdaji certifikata na osnovi izvedenega kontrolnega pregleda / vrednotenja in pridobljenih dokazil o skladnosti proizvodov z zahtevami Pravilnika o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja z vsemi spremembami in dopolnitvami (Ur. l. RS 31/23 s sprem. in dop.):</td>
			</tr> 
			<tr>
				<td class="fake-td">Odločitev:</td>
				<td>{{ certifikat.porocilo.odlocitev.odlocitev.join(", ") }}</td>
			</tr>
			<tr>
				<td class="fake-td">Št. certifikata:</td>
				<td>{{ certifikat.stcertifikata }}</td>
			</tr>
            <tr>
				<td class="fake-td">Izdan dne:</td>
				<td>{{ certifikat.datumizdaje }}</td>
			</tr>
            <tr>
				<td class="fake-td">Veljaven do:</td>
				<td>{{ certifikat.datumveljavnosti }}</td>
			</tr>
            <tr>
				<td class="fake-td">Obseg certificiranja:</td>
				<td>{{ certifikat.vrsterastlin.map(r=>r.naziv).join(", ") }}</td>
			</tr>
            <tr>
				<td class="fake-td">Pregledal:</td>
				<td>{{ certifikat.porocilo.pregled.kontrolor.naziv }}</td>
			</tr>
            <tr>
				<td class="fake-td">Odločitev sprejel:</td>
				<td>{{ certifikat.porocilo.odlocitev.kontrolor.naziv }}</td>
			</tr>

			<tr>
				<td colspan="2" style="font-size:0.8em;text-align: justify;" >Izvajalec je dolžan certifikacijskemu organu (IKC UM) sporočati vse spremembe, vezane na postopek certificiranja, v roku 15 dni od nastale spremembe. V primeru spremembe obsega certificiranja (širitve, oženja) so zahteve in roki določeni v javno dostopnem dokumentu Pravila postopka certificiranja, 1.80doc (www.ikc-um.si). Izvajalec je dolžan redno voditi in osveževati dokumentarno evidenco, ki naj bo na zahtevo nadzornega organa dosegljiva v vsakem trenutku. V primeru nadzora pristojnega organa, ki vpliva na skladnost postopka certificiranja, dejavnosti izvajalca ali izdan certifikat, izvajalec o tem IKC UM obvesti najkasneje v roku 15 dni. </td>
			</tr> 

		</table>

        <table class="mt-1 telo" style="width:100%;">
        <tr>
		<td style="font-size:0.8em;text-align: justify;"><u>Pouk o pravnem sredstvu:</u></td>
		</tr>
        <tr>
        <td style="font-size:0.8em;text-align: justify;">
        Zoper poročilo o certifikaciji je možen <b>priziv</b> oz. ugovor v roku 15 dni od prejema. Priziv se lahko vloži v skladu z navodili določenimi v veljavnem dokumentu 1.80doc Pravila postopka certificiranja, ki je dostopen na spletni strani IKC UM (www.ikc-um.si).
        </td>
        </tr>
        <tr>
        <td style="font-size:0.8em;text-align: justify;">
        V primeru opaženih slovničnih ali tiskarskih napak na certifikatu ali poročilu o certifikaciji, lahko v roku 15 dni od prejema certifikata oz. poročila o napaki seznanite IKC UM.
        </td>
        </tr>
		</table>

		
        <table class="mt-1 telo" style="width:100%;break-inside: avoid ;">
            <colgroup>
				<col style="width:70%">
				<col style="width:25%">
			</colgroup>  
            <tr>
                <td>Poročilo izpisal/a<br/>{{ certifikat.porocilo.ustvaril }}<br/>{{certifikat.porocilo.vloga  }}</td>
                <td>Katja Sabolič<br/>direktorica</td>
            </tr>
        </table>

		<table v-if="certifikat.porocilo.priloge.length>0" class="obroba mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:100%">
    		</colgroup>  
            <tr>
				<td ><u>Priloge:</u></td>
			</tr> 
			
            <tr v-for="priloga in certifikat.porocilo.priloge">
			<td>- {{priloga}}</td>
            
           
			</tr> 
            

        </table>
	
    </div>
    </div>
   

</template>

<style scoped>

	.telo, .obroba, .zapisnik-podatki{
        font-size: 0.8em;
    }
	.gumbtiskajskrit {
            display:none;
        }
	.zapisnik-glava{
		
		background-color:#d9d9d9;
		border:1px solid black;
		text-align: center;
		padding:1mm;
	
	}
	.zapisnik-glava h2{
		color:black;

	}
	table.zapisnik-podatki,table.obroba {
		width:100%;
	}
	table.obroba, table.obroba td, table.zapisnik-podatki, table.zapisnik-podatki td{
		border: 1px solid black;
		border-collapse: collapse;
		
	} 
	table.zapisnik-podatki td,table.obroba td{
		padding-left: 1mm;
		padding-right: 1mm;
	}
	table.zapisnik-podatki td .multi-td{
		display:flex;
		border:none;
		 align-items: stretch;
		  height: 100%;
	}
	table.zapisnik-podatki td .multi-td div{
		flex: 1 1 33%;
		padding-left: 1mm;
		padding-right: 1mm;

	}
	table.zapisnik-podatki td .multi-td div:first-child{
		
		padding-left: 0;
		

	}
	table.zapisnik-podatki th{
		font-weight: normal;
		background-color:#d9d9d9;
		text-align: left;
		border: 1px solid black;
		border-collapse: collapse;
		padding-left: 1mm;
		padding-right: 1mm;
	}
	table.zapisnik-podatki td:first-child,.fake-td{
		background-color:#d9d9d9;
		border-left:1px solid black;
		border-right:1px solid black;
		
	}
	.td-bold {
		font-weight: bold;
	}
	table.zapisnik-podatki td.td-regular {
	background-color:white;
	}
	.zapisnik-tabela-glava {
		background-color:var(--accent) !important;
		color:black;
		font-weight: bold;;

	}
	.mt-1 {
	margin-top: 1rem !important;
	}

	.display-row{
		display:flex;
		align-items:center;
		gap:1rem;
		
	}
	.display-row-form>*:first-child{
		flex:0 0 25%;
	}


h1,h2,h3{
  font-size:5mm;
  line-height:5mm;
}

@media print {
.sekcija-nb {
  break-inside: avoid!important;
	  }
}

.noga-noter {

display:    flex ;
flex-direction:     row ;
justify-content:    end;
margin-top:2rem;
}

.datum,.podpis {
  margin-right: 10rem;
  font-size: 1rem;
}


.tabela-kultura-wrapper {
  column-count:2;
  
}
.tabela-proizvod-wrapper {
  column-count:3;
  
}
.tabela{
  width: 100%;
  table-layout: fixed;
}
.tabela th {
  font-size: 0.5rem;
}


.tabela td,.tabela,.tabela th {
  
  border: 1px solid green;
  border-collapse: collapse;
  padding:3px;
  font-size: 0.7rem;
}

label,textarea{
  break-inside: avoid !important;
   
}
.glava{
  
  display:    flex ;
  flex-direction:     row ;
  justify-content:    space-between  ;

}
.levi-logo  {
 position:   running(obrazecLeviLogo); 
}  

.levi-logo img{
  height: 2cm;

}
.desni-info {
  position:   running(obrazecDesniInfo);
}

.desni-info p{
  
  margin: 0;
  font-size:  0.4cm;
  line-height:   0.4cm;
  text-align:     right   ;
}



.noga {

  position:   running(obrazecNoga);
  font-size: 3mm ;
  line-height:5mm;
  display:    flex ;
  flex-direction:     row ;
  justify-content:    space-between;
}

.stevilka-strani:after{
content: counter(page) " od " counter(pages);
}


label.k-form-field{
  font-weight:    bold;
  font-size:  0.8em;
  line-height:    0.8em;
  margin-top:2mm;
  margin-bottom:1mm;
}
.posta input:nth-child(1){
  flex-basis: 15%;
  margin-right: 3mm;

}
h6{
  font-size: 0.7em;
}

.sekcija {
  margin-top:5mm;
  border:   1px solid green;
  padding: 2mm;
 
}
.sekcija-pb1 {
  padding-bottom:1mm;
}

.posebnosti .seznamkategorij
{
  border-bottom:  1px solid green;
}
.izjava ul{
  list-style-type: disc;
margin-top: 3mm;
margin-bottom: 3mm;
margin-left: 0;
margin-right: 0;
padding-left: 10mm;
}
.vrsticapodpisa div {
  flex-basis: 50%;
}
.noga-izven{
position:  running(nogaRunning);
font-size: 3mm ;
line-height:5mm;

}

.zacetek-strani {
break-before: always;
}

@page {

margin-top: 30mm;
margin-bottom: 20mm;
margin-left: 10mm;
margin-right: 10mm;
size: A4 portrait;

@bottom-right {
content:  element(nogaRunning);
vertical-align: middle;
}
@top-left {
content:  element(obrazecLeviLogo);
vertical-align: middle;
}

@top-right {
content:  element(obrazecDesniInfo);
vertical-align: middle;
}


}


</style>
<script>

import { mapState, mapActions,mapMutations } from 'vuex'
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { Previewer,registerHandlers,Handler  } from 'pagedjs';


class RepeatingTableHeaders extends Handler {
 
	
    constructor(chunker, polisher, caller) {
        super(chunker, polisher, caller);
        this.splitTablesRefs = [];
    }
	beforeParsed(content) {
		//console.log("Before preview!!!!!!!!!!!!!!!!!!!!!!")
		console.log(content);
		let gumbtiskaj=content.getElementById('tiskaj');
		//console.log("najdem gumb tiskaj")
		gumbtiskaj.remove();
		this.gumbtiskaj=gumbtiskaj;
	}
	afterPreview(content, renderTo) {
		let gumbtiskaj=this.gumbtiskaj;
		console.log("After preview!!!!!!!!!!!!!!!!!!!!!!")
		console.log(this.gumbtiskaj);
		gumbtiskaj.style.position="fixed";
		gumbtiskaj.style.top="20px";
		gumbtiskaj.style.right="20px";
		gumbtiskaj.style.right="20px";
		gumbtiskaj.onclick=function(){
			this.remove();
			window.print();
			document.body.appendChild(this);
		}
		document.body.appendChild(this.gumbtiskaj);
		}

    afterPageLayout(pageElement, page, breakToken, chunker) {
		console.log("after afterPageLayout!!!!!!!!!!!!!!!!!!!!!!")
        this.chunker = chunker;
        this.splitTablesRefs = [];

        if (breakToken) {
            const node = breakToken.node;
            const tables = this.findAllAncestors(node, "table");
            if (node.tagName === "TABLE") {
                tables.push(node);
            }

            if (tables.length > 0) {
                this.splitTablesRefs = tables.map(t => t.dataset.ref);

                //checks if split inside thead and if so, set breakToken to next sibling element
                let thead = node.tagName === "THEAD" ? node : this.findFirstAncestor(node, "thead");
                if (thead) {
                    let lastTheadNode = thead.hasChildNodes() ? thead.lastChild : thead;
                    breakToken.node = this.nodeAfter(lastTheadNode, chunker.source);
                }

                this.hideEmptyTables(pageElement, node);
            }
        }
    }

    hideEmptyTables(pageElement, breakTokenNode) {
        this.splitTablesRefs.forEach(ref => {
            let table = pageElement.querySelector("[data-ref='" + ref + "']");
            if (table) {
                let sourceBody = table.querySelector("tbody > tr");
                if (!sourceBody || this.refEquals(sourceBody.firstElementChild, breakTokenNode)) {
                    table.style.visibility = "hidden";
                    table.style.position = "absolute";
                    let lineSpacer = table.nextSibling;
                    if (lineSpacer) {
                        lineSpacer.style.visibility = "hidden";
                        lineSpacer.style.position = "absolute";
                    }
                }
            }
        });
    }

    refEquals(a, b) {
        return a && a.dataset && b && b.dataset && a.dataset.ref === b.dataset.ref;
    }

    findFirstAncestor(element, selector) {
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                return element.parentNode;
            }
            element = element.parentNode;
        }
        return null;
    }

    findAllAncestors(element, selector) {
        const ancestors = [];
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                ancestors.unshift(element.parentNode);
            }
            element = element.parentNode;
        }
        return ancestors;
    }

    // The addition of repeating Table Headers is done here because this hook is triggered before overflow handling
    layout(rendered, layout) {
        this.splitTablesRefs.forEach(ref => {
            const renderedTable = rendered.querySelector("[data-ref='" + ref + "']");
            if (renderedTable) {
                // this event can be triggered multiple times
                // added a flag repeated-headers to control when table headers already repeated in current page.
                if (!renderedTable.getAttribute("repeated-headers")) {
                    const sourceTable = this.chunker.source.querySelector("[data-ref='" + ref + "']");
                    this.repeatColgroup(sourceTable, renderedTable);
                    this.repeatTHead(sourceTable, renderedTable);
                    renderedTable.setAttribute("repeated-headers", true);
                }
            }
        });
    }

    repeatColgroup(sourceTable, renderedTable) {
        let colgroup = sourceTable.querySelectorAll("colgroup");
        let firstChild = renderedTable.firstChild;
        colgroup.forEach((colgroup) => {
            let clonedColgroup = colgroup.cloneNode(true);
            renderedTable.insertBefore(clonedColgroup, firstChild);
        });
    }

    repeatTHead(sourceTable, renderedTable) {
        let thead = sourceTable.querySelector("thead");
        if (thead) {
            let clonedThead = thead.cloneNode(true);
            renderedTable.insertBefore(clonedThead, renderedTable.firstChild);
        }
    }

    // the functions below are from pagedjs utils/dom.js
    nodeAfter(node, limiter) {
        if (limiter && node === limiter) {
            return;
        }
        let significantNode = this.nextSignificantNode(node);
        if (significantNode) {
            return significantNode;
        }
        if (node.parentNode) {
            while ((node = node.parentNode)) {
                if (limiter && node === limiter) {
                    return;
                }
                significantNode = this.nextSignificantNode(node);
                if (significantNode) {
                    return significantNode;
                }
            }
        }
    }

    nextSignificantNode(sib) {
        while ((sib = sib.nextSibling)) {
            if (!this.isIgnorable(sib)) return sib;
        }
        return null;
    }

    isIgnorable(node) {
        return (node.nodeType === 8) || // A comment node
            ((node.nodeType === 3) && this.isAllWhitespace(node)); // a text node, all whitespace
    }

    isAllWhitespace(node) {
        return !(/[^\t\n\r ]/.test(node.textContent));
    }

}

registerHandlers(RepeatingTableHeaders);



export default {
  components:{'kbutton': Button,
},
  props: ["certifikatid"],
    data () {
        return {
            podrocjacertificiranja:[{"naziv":"IPS","id":1, "prikaz":"IPSO"},{"naziv":"IPG","id":2, "prikaz":"IPG"},{"naziv":"IPP","id":3, "prikaz":"IPP"},{"naziv":"IPZ","id":4, "prikaz":"IPZ"},{"naziv":"IPH","id":5, "prikaz":"IPH"}],
        }
    },
      computed: {
	
        ...mapState({certifikat(state) {
                 return state.certifikat.certifikat;
             }}), 
           },

    created () {
    
    this.vrniPoId({id:this.certifikatid}).then(()=>{
    var stcertifikata=this.certifikat.stcertifikata;
    this.$nextTick(function () {
        let html=document.getElementById('html');
        let paged = new Previewer();
        paged.preview();
        });
    });
    },
  


    methods: {
  ...mapActions('certifikat', ['vrniPoId']),
       
        
    }
};
</script>

